import React from 'react';

import Box from '@mui/material/Box';

import { RED } from '../../../theme/colorConstants';

const RequiredMark = () => (
  <Box component="span" aria-hidden sx={{ color: RED[50], marginLeft: '4px' }}>
    *
  </Box>
);

export default RequiredMark;
